import React from 'react';
import { AppBar, Button, Grid, Stack, Toolbar } from "../../styles/MaterialUI";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';

const PrivacyPolicy = () => {
    return (
        <Grid container item xs={12} style={{ width: "100%" }}>
            <Grid container item xs={12} justifyContent="flex-start" alignItems="center"
                sx={{
                    borderColor: "#ff8000", borderTop: '4px solid #ff8000', borderBottom: '1px solid #cecece',
                    borderLeft: 'none', borderRight: 'none', marginTop: "-25px", padding: "15px"
                }}
            >
                <Button variant="text" size="small" sx={{ color: "#000000" }}>
                    <PhoneIcon sx={{ fontSize: "15px", mr: 0.2, color: "#ff8000" }} />
                    +1 (833) 327 4273
                </Button>

                <Button variant="text" size="small" sx={{ color: "#000000", textTransform: "none" }}>
                    <EmailOutlinedIcon sx={{ fontSize: "15px", mr: 0.2, color: "#ff8000" }} />
                    info@intellidash.net
                </Button>
            </Grid>
            <AppBar position="sticky" title="AristoCAST" sx={{ backgroundColor: "#fff", boxShadow: "none" }}>
                <Toolbar variant="dense">
                    <Grid container item xs={6} sx={{ marginLeft: "-5px" }}>
                        <img src="AristoCast_logo_v2.png" alt="AristoCast Logo" style={{ width: "133px", marginTop: 2 }} />
                    </Grid>
                </Toolbar>
            </AppBar>
            <Grid container item xs={12} padding={2} style={{ marginTop: "-10px" }}>
                <Grid item xs={12} px={30} sx={{
                    "@media (max-width: 1024px)": {
                        paddingLeft: "2px", paddingRight: "2px"
                    }
                }}>
                    <Stack display="flex" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
                        <h2 style={{ fontSize: "40px", textAlign: "center", color: "#333333", margin: 0 }}>Privacy Policy</h2>
                    </Stack>
                    <Stack display="flex" justifyContent="flex-start" alignItems="flex-start" sx={{ width: '100%' }}>
                        <h2 style={{ fontSize: "14px", color: "#333333", margin: 0 }}>PRIVACY NOTICE</h2>
                        <strong style={{ fontSize: "14px", color: "#333333", margin: 0 }}>Last updated May 23, 2024</strong>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Privacy Policy for AristoCAST</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            Intellidash, located in Dublin (565 Metro Place South, Ste 300 Dublin, OH 43017), operates the
                            mobile application AristoCast (App).
                            This page informs you of our policies regarding the collection, use, and disclosure of personal
                            data when you use our App and the choices you have associated with that data.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Information Collection and Use</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            We do not collect any personal information from users of our App for marketing or advertising
                            purposes. The App is designed to receive data from a Content Management System (CMS) for
                            the purpose of displaying images, videos, and dynamic content to construct a dashboard for the
                            user.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Activation and Account Information</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            To use certain features of the App, users may need to activate their accounts using a QR code
                            displayed within the App. This QR code is used for account verification and broadcasting
                            purposes within the CMS. We do not store or collect any personal information during this
                            activation process.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Log Data</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            We do not collect any log data from the use of our App.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Cookies</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            The App does not use cookies.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Service Providers</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            We do not use any third-party service providers to collect or manage data from the App.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Security</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            We take the security of your personal information seriously. For data transmission, we use
                            Advanced Encryption Standard (AES) protocols and Secure Sockets Layer (SSL) technology.
                            This ensures that data transmitted between your device and our servers is encrypted and
                            secure, reducing the risk of unauthorized access or interception. Additionally, our servers are
                            regularly monitored and maintained to mitigate potential security risks.
                            We follow industry-standard security measures to protect your data, it's important that we
                            continuously update and enhance our security practices to safeguard your information to the
                            best of our ability.
                        </p>

                        <p><strong style={{ fontSize: "14px", color: "#333333" }}>Changes to This Privacy Policy</strong></p>
                        <p style={{ fontSize: "14px", color: "#333333", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            We may update our Privacy Policy from time to time. You are advised to review this Privacy
                            Policy periodically for any changes. Changes to this Privacy Policy are effective when they are
                            posted on this page.
                        </p>
                    </Stack>
                </Grid>
            </Grid>
            <Grid container item xs={12} padding={2} style={{ padding: "15px", backgroundColor: "#3b3b3b" }}>
                <Grid item xs={12} px={30} sx={{
                    "@media (max-width: 1024px)": {
                        paddingLeft: "2px", paddingRight: "2px"
                    }
                }}>
                    <Stack display="flex" justifyContent="flex-start" alignItems="flex-start" sx={{ width: '100%' }}>
                        <p><strong style={{ fontSize: "14px", color: "#ffffff" }}>Contact Us</strong></p>
                        <p style={{ fontSize: "14px", color: "#ffffff", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            <Button variant="text" size="small" sx={{ color: "#ffffff" }}>
                                <PhoneIcon sx={{ fontSize: "15px", mr: 0.2, color: "#ff8000" }} />
                                +1 (833) 327 4273
                            </Button>
                        </p>
                        <p style={{ fontSize: "14px", color: "#ffffff", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            <Button variant="text" size="small" sx={{ color: "#ffffff", textTransform: "none" }}>
                                <EmailOutlinedIcon sx={{ fontSize: "15px", mr: 0.3, color: "#ff8000" }} />
                                info@intellidash.net
                            </Button>
                        </p>
                        <p style={{ fontSize: "14px", color: "#ffffff", textAlign: "left", lineHeight: "20px", marginTop: "-10px" }}>
                            <Button variant="text" size="small" sx={{ color: "#ffffff", textTransform: "none" }}>
                                <LocationOnSharpIcon sx={{ fontSize: "15px", mr: 0.2, color: "#ff8000" }} />
                                565 Metro Place South, Ste 300 Dublin, OH 43017
                            </Button>
                        </p>
                    </Stack>
                </Grid>
            </Grid>
            <Grid container item xs={12} padding={2} style={{ padding: "15px", backgroundColor: "#43464C" }}>
                <p style={{ fontSize: "14px", textAlign: "center", color: "#cecece", width: "100%", margin: 0 }}>
                    Copyright © 2024 IntelliDash. All rights reserved
                </p>
            </Grid>
        </Grid>
    )
}

export default PrivacyPolicy
